export const ExternalSourceName = {
  MCB: "MCB",
  EDR: "Rothschild"
}


export const ExternalSourcesList = [
  {
    name: 'All',
    value: ''
  },
  {
    name: 'MCB',
    value: ExternalSourceName.MCB
  },
  {
    name: 'EDR',
    value: ExternalSourceName.EDR
  }
]



// WEBPACK FOOTER //
// ./src/app/common/enums/ExternalSources.ts